import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  INVITATIONS_FEATURE_KEY,
  State,
  invitationsAdapter,
} from './invitations.reducer';

// Lookup the 'Invitations' feature state managed by NgRx
export const getInvitationsState = createFeatureSelector<State>(
  INVITATIONS_FEATURE_KEY,
);

const { selectAll, selectEntities } = invitationsAdapter.getSelectors();

export const getInvitationsLoaded = createSelector(
  getInvitationsState,
  (state: State) => state.loaded,
);

export const getInvitationsError = createSelector(
  getInvitationsState,
  (state: State) => state.error,
);

export const getAllInvitations = createSelector(
  getInvitationsState,
  (state: State) => selectAll(state),
);

export const getInvitationsEntities = createSelector(
  getInvitationsState,
  (state: State) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getInvitationsState,
  (state: State) => state.selectedId,
);

export const getSelected = createSelector(
  getInvitationsEntities,
  getSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
);
